import { render, staticRenderFns } from "./RoleAuth.vue?vue&type=template&id=0e08444a&scoped=true"
import script from "./RoleAuth.vue?vue&type=script&lang=js"
export * from "./RoleAuth.vue?vue&type=script&lang=js"
import style0 from "./RoleAuth.vue?vue&type=style&index=0&id=0e08444a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e08444a",
  null
  
)

export default component.exports